import type { DeepResolved } from '@/types/content'

import type {
  RsPlusSchoolScenesContent,
  RsPlusSchoolScenesTeaseContent
} from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export const rsPlusSchoolScenesTeaseFallback: RsPlusSchoolScenesTeaseContent = {
  internalName: '',
  heading: '',
  body: '',
  ctaLabel: '',
  badgeLabel: '',
  image: {
    assetId: '',
    alt: '',
    url: ''
  }
}

export const rsPlusSchoolScenesContentFallback: DeepResolved<RsPlusSchoolScenesContent> = {
  internalName: '',
  groupTitle: '',
  groupDescription: '',
  tease: rsPlusSchoolScenesTeaseFallback
}
